import React, { useState } from "react";
import ProductOrderModal from "./ProductOrderModal/ProductOrderModal";
import { motion } from "framer-motion";

export const ProductCard = ({ product,onDetails }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300">

        {/* Image */}
        <div className="h-56 overflow-hidden bg-stone-50">
          <motion.img
            src={product.images[0]}
            alt={product.title}
            className="w-full h-full object-cover"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.4 }}
          />
        </div>


        {/* Content */}
        <div className="p-5 md:p-4 flex flex-col flex-1">

          {/* Title */}
          <h3 className="text-xl font-bold text-amber-950 leading-relaxed">
            {product.title}
          </h3>


         


          {/* Coffee Profile */}
          <div className="grid grid-cols-3 mt-6 pt-4 border-t border-stone-100">

            <div className="text-center px-2">

              <p className="text-xs text-stone-400">
                اسیدیته
              </p>

              <p className="mt-1 text-xs font-semibold text-amber-950 md:truncate max-w-[120px] mx-auto" title={product.profile.acidity}>
                {product.profile.acidity}
              </p>

            </div>


            <div className="text-center border-x border-stone-100">

              <p className="text-xs text-stone-400">
                بادی
              </p>

              <p className="mt-1 text-xs font-semibold text-amber-950">
                {product.profile.body}
              </p>

            </div>


            <div className="text-center">

              <p className="text-xs text-stone-400">
                رُست
              </p>

              <p className="mt-1 text-sm font-semibold text-amber-950 md:truncate max-w-[120px] mx-auto" title={product.profile.acidity}>
                {product.profile.roast}
              </p>

            </div>
          </div>

          <div className="mt-auto pt-5">

            <div className="flex items-center gap-3">

              {/* Button */}
              <button
                onClick={(event) => {
                  event.stopPropagation();
                  setOpenModal(true);
                }}
                className="w-full mt-5 bg-[#FF8C42]/10 text-darkgreen400 hover:text-[#FF6F00] border border-[#FF8C42]/30 py-3 rounded-xl font-medium hover:bg-[#FF8C42]/25 hover:border-[#FF6F00] hover:shadow-md hover:shadow-[#FF8C42]/20 transition-all duration-200 active:scale-[0.98]"
              >
               مشاهده جزئیات
              </button>
            </div>
          </div>

        </div>

      </div>

      {openModal && (
        <ProductOrderModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          product={product}
        />
      )}
    </>
  );
};

export default ProductCard;
